import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { BsFilterLeft } from 'react-icons/bs';
import { IoCloseOutline } from 'react-icons/io5';

import styled from 'styled-components';
import filterOptions from '../../assets/data/filters.json';

const SelectorGroup = styled.div`
  margin-bottom: 1rem;
`;

const SelectorLabel = styled.p`
  text-transform: uppercase;
  font-size: 0.75rem;
  margin-bottom: 0.25rem;
  color: $d-gray;
  letter-spacing: 0.25px;
`;

const HomerunSelector = styled.select`
  border-radius: 3px;
  border: 1px solid $offblack;
  display: inline-block;
  font-weight: 400;
  padding: .5rem 1.5rem .5rem .5rem;
  border: 1px solid rgb(175,175,175);
  box-shadow: 0 1px 0 1px rgba(0,0,0,.04);
  border-radius: .5em;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background-color: #fff;
  background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E'), linear-gradient(to bottom, #ffffff 0%,#ffffff 100%);
  background-repeat: no-repeat, repeat;
  background-position: right .7em top 50%, 0 0;
  background-size: .65em auto, 100%;
  width: 100%;
  color: black;
`;

const OrtizButton = styled.button`
  width: 100%;
  background-color: #005DC7;
  border: 1px solid #10529d;
  padding: 0.5rem;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.25s ease-out;
  font-size: 0.75rem;
  color: white;
  border-radius: 5px;
  max-width: 150px;
  margin: 0 auto;
  display: block;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  &:hover {
    background-color: #1973d9;
  }
`;

const OrtizSelects = ({
  updateFilters,
  clearFilters,
  opponentFilter,
  yearFilter,
  seasonTypeFilter,
  seriesTypeFilter,
  venueFilter,
  resultFilter,
  walkoffFilter,
  filtersDisabled,
  filterDisplay,
  setFilterDisplay,
}) => {
  const toggleFilters = () => {
    setFilterDisplay(!filterDisplay);
  };

  const venues = filterOptions.stadium.sort((a, b) => {
    if (a.name > b.name) {
      return 1;
    } return -1;
  });

  const displayClass = filterDisplay === true ? 'selectors--visible' : 'selectors--hiden';
  const disabledClass = filtersDisabled === true ? 'selectors--disabled' : 'selectors--enabled';

  return (
    <div
      id="homerun__selectors"
      className={`${displayClass} ${disabledClass}`}
    >
      <SelectorGroup>
        <SelectorLabel className="bentonsanscond-n4">Opponent</SelectorLabel>
        <HomerunSelector
          className="homerun__selector"
          data-id="opponent"
          value={opponentFilter}
          onChange={(e) => updateFilters(e)}
        >
          <option value="all" key="team-selector-all">All opponents</option>
          {filterOptions.teams.map((team) => <option value={team.abbr} key={`team-selector-${team.abbr}`}>{team.full}</option>)}
        </HomerunSelector>
      </SelectorGroup>

      <SelectorGroup>
        <SelectorLabel className="bentonsanscond-n4">Year</SelectorLabel>
        <HomerunSelector
          className="homerun__selector"
          data-id="year"
          value={yearFilter}
          onChange={(e) => updateFilters(e)}
        >
          <option value="all" key="year-selector-all">All years</option>
          {filterOptions.years.map((year) => <option value={year} key={`year-selector-${year}`}>{year}</option>)}
        </HomerunSelector>
      </SelectorGroup>

      <SelectorGroup>
        <SelectorLabel className="bentonsanscond-n4">Season Type</SelectorLabel>
        <HomerunSelector
          className="homerun__selector"
          data-id="seasonType"
          value={seasonTypeFilter}
          onChange={(e) => updateFilters(e)}
        >
          <option value="all" key="season-selector-all">All season types</option>
          {filterOptions.seasonType.map((season, i) => <option value={season} key={`season-selector-${season}`}>{season}</option>)}
        </HomerunSelector>
      </SelectorGroup>

      <SelectorGroup>
        <SelectorLabel className="bentonsanscond-n4">Postseason series</SelectorLabel>
        <HomerunSelector
          className="homerun__selector"
          data-id="seriesType"
          value={seriesTypeFilter}
          onChange={(e) => updateFilters(e)}
        >
          <option value="all" key="series-selector-all">All series types</option>
          {filterOptions.seriesType.map((series) => <option value={series} key={`series-selector-${series}`}>{series}</option>)}
        </HomerunSelector>
      </SelectorGroup>

      <SelectorGroup>
        <SelectorLabel className="bentonsanscond-n4">Stadium</SelectorLabel>
        <HomerunSelector
          className="homerun__selector"
          data-id="venue"
          value={venueFilter}
          onChange={(e) => updateFilters(e)}
        >
          <option value="all" key="stadium-selector-all">All venues</option>
          {venues.map((stadium) => <option value={stadium.name} key={`stadium-selector-${stadium.name}`}>{stadium.name}</option>)}
        </HomerunSelector>
      </SelectorGroup>

      <SelectorGroup>
        <SelectorLabel className="bentonsanscond-n4">Result</SelectorLabel>
        <HomerunSelector
          className="homerun__selector"
          data-id="result"
          value={resultFilter}
          onChange={(e) => updateFilters(e)}
        >
          <option value="all" key="result-selector-all">All results</option>
          {filterOptions.resultType.map((result) => <option value={result.toLowerCase()} key={`result-selector-${result}`}>{result}</option>)}
        </HomerunSelector>
      </SelectorGroup>

      <SelectorGroup>
        <SelectorLabel className="bentonsanscond-n4">Walkoff</SelectorLabel>
        <HomerunSelector
          className="homerun__selector"
          data-id="walkoff"
          value={walkoffFilter}
          onChange={(e) => updateFilters(e)}
        >
          <option value="all" key="walkoff-selector-all">Either</option>
          {filterOptions.walkoff.map((w) => <option value={w} key={`walkoff-selector-${w}`}>{w}</option>)}
        </HomerunSelector>
      </SelectorGroup>
      <OrtizButton id="hr__filters-clear" className="ortiz__button benton-n4" type="button" onClick={() => clearFilters()}>Clear</OrtizButton>
      <OrtizButton id="hr__filters-display" className="ortiz__button benton-n4" type="button" onClick={() => toggleFilters()}>
        {filterDisplay === false && <BsFilterLeft /> }
        {filterDisplay === true && <IoCloseOutline /> }
      </OrtizButton>
    </div>
  );
};

export default OrtizSelects;

OrtizSelects.propTypes = {
  opponentFilter: PropTypes.string.isRequired,
  yearFilter: PropTypes.string.isRequired,
  seasonTypeFilter: PropTypes.string.isRequired,
  seriesTypeFilter: PropTypes.string.isRequired,
  venueFilter: PropTypes.string.isRequired,
  resultFilter: PropTypes.string.isRequired,
  updateFilters: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  walkoffFilter: PropTypes.string.isRequired,
  filtersDisabled: PropTypes.bool.isRequired,
  filterDisplay: PropTypes.bool.isRequired,
  setFilterDisplay: PropTypes.func.isRequired,
};
